<div class="seh-page">
  <header class="seh-toolbar">
    <div class="seh-search-wrap">
      <div class="seh-search-field">
        <span class="material-symbols-outlined seh-search-icon" aria-hidden="true">search</span>
        <input
          type="search"
          class="seh-search-input"
          placeholder="Search schedule..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchInput()"
          (keyup.enter)="onSearch()"
          aria-label="Search by schedule name"
        />
        <button
          *ngIf="showClearSearch"
          type="button"
          class="seh-clear-btn"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </div>
    </div>

    <button type="button" class="seh-refresh-btn" (click)="reload()" [disabled]="loading">
      <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
      Refresh
    </button>
  </header>

  <div *ngIf="loading" class="seh-state" role="status">Loading schedule history…</div>

  <div *ngIf="!loading && errorMessage" class="seh-state seh-state--error" role="alert">
    {{ errorMessage }}
    <button type="button" class="seh-link" (click)="reload()">Retry</button>
  </div>

  <ng-container *ngIf="!loading && !errorMessage">
    <section class="seh-panel">
      <p *ngIf="!history.length" class="seh-empty">No history found.</p>

      <div *ngIf="history.length" class="seh-table" role="table" aria-label="Schedule execution history">
        <div class="seh-row seh-row--header" role="row">
          <span class="seh-col seh-col--expand" role="columnheader" aria-hidden="true"></span>
          <!-- <span class="seh-col seh-col--status" role="columnheader">Status</span> -->
          <span class="seh-col seh-col--schedule" role="columnheader">Schedule</span>
          <span class="seh-col seh-col--triggered" role="columnheader">Triggered At</span>
          <span class="seh-col seh-col--user" role="columnheader">Triggered By</span>
        </div>

        <div
          *ngFor="let row of history; trackBy: trackByHistoryId"
          class="seh-row-group"
          [class.seh-row-group--expanded]="isExpanded(row)"
        >
          <button
            type="button"
            class="seh-row seh-row--data"
            [class.seh-row--expanded]="isExpanded(row)"
            role="row"
            (click)="toggleRow(row)"
            [attr.aria-expanded]="isExpanded(row)"
          >
            <span class="seh-col seh-col--expand" role="cell">
              <span class="material-symbols-outlined seh-expand-icon" aria-hidden="true">
                {{ isExpanded(row) ? 'expand_less' : 'expand_more' }}
              </span>
            </span>
            <!-- <span class="seh-col seh-col--status" role="cell">
              <span
                class="status-pill"
                [ngClass]="getScheduleRowStatus(row).cssClass"
                [class.status-pill--animated]="getScheduleRowStatus(row).isRunning"
              >
                <span class="status-pill__dot" aria-hidden="true"></span>
                {{ getScheduleRowStatus(row).label | uppercase }}
              </span>
            </span> -->
            <span class="seh-col seh-col--schedule" role="cell">
              <span class="seh-schedule-name">{{ row.schedule_name || '—' }}</span>
            </span>
            <span class="seh-col seh-col--triggered" role="cell">{{ row.fired_at_label || '—' }}</span>
            <span class="seh-col seh-col--user" role="cell">{{ row.created_by || '—' }}</span>
          </button>

          <div *ngIf="isExpanded(row)" class="seh-expand-panel" (click)="$event.stopPropagation()">
            <!-- <div class="seh-expand-panel__label">Suite executions</div> -->
            <div class="seh-suite-toolbar">
              <div class="seh-search-wrap">
                <div class="seh-search-field">
                  <span class="material-symbols-outlined seh-search-icon" aria-hidden="true">search</span>
                  <input
                    type="search"
                    class="seh-search-input"
                    placeholder="Search suite..."
                    [(ngModel)]="suiteSearchQuery"
                    (ngModelChange)="onSuiteSearchInput()"
                    (keyup.enter)="onSuiteSearch()"
                    aria-label="Search by suite name"
                  />
                  <button
                    *ngIf="showClearSuiteSearch"
                    type="button"
                    class="seh-clear-btn"
                    (click)="clearSuiteSearch()"
                    aria-label="Clear suite search"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">close</span>
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="loadingSuites" class="seh-state seh-state--compact" role="status">Loading suites…</div>

            <div *ngIf="!loadingSuites && suiteErrorMessage" class="seh-state seh-state--error seh-state--compact" role="alert">
              {{ suiteErrorMessage }}
              <button type="button" class="seh-link" (click)="retryLoadSuites()">Retry</button>
            </div>

            <div *ngIf="!loadingSuites && !suiteErrorMessage && isSequentialLog" class="seh-sequence-note">
              Sequential run: suites run one after another in the order shown.
              <span *ngIf="!logContinueOnFailure">If a suite fails or is aborted, the remaining suites are aborted.</span>
            </div>

            <div *ngIf="!loadingSuites && !suiteErrorMessage" class="seh-suite-list">
              <div
                *ngFor="let entry of suiteEntries; trackBy: trackBySuiteEntryIndex"
                class="seh-suite-card"
              >
                <div class="seh-suite-card__left">
                  <div class="seh-suite-card__title">
                    <!-- <span class="seh-suite-code">{{ getSuiteCode(entry) }}</span> -->
                    <span *ngIf="isSequentialLog && entry.sequence_number" class="seh-sequence-no">{{ entry.sequence_number }}</span>
                    <span class="seh-suite-name">{{ entry.suite_name || 'Suite' }}</span>
                    <!-- <span class="seh-tag seh-tag--web">WEB</span> -->
                    <span
                      class="seh-suite-status"
                      [ngClass]="suiteStatusClass(entry)"
                      [class.seh-suite-status--animated]="getSuiteRunKind(entry) === 'running' || getSuiteRunKind(entry) === 'aborting'"
                    >
                      {{ getSuiteStatusLabel(entry) }}
                    </span>
                  </div>
                  <div class="seh-suite-card__sub">
                    <span
                      *ngFor="let browser of (entry.browsers || []); let last = last"
                      class="seh-browser-badge"
                    >{{ formatBrowser(browser) }}</span>
                  </div>
                </div>

                <div class="seh-suite-card__right">
                  <div class="seh-view-report-wrap"
                    [class.seh-view-report-wrap--disabled]="!(entry.execution_id && entry.execution_id.$oid)" 
                    [attr.data-tooltip]="!(entry.execution_id && entry.execution_id.$oid)
                    ? (entry.error_message || 'Execution didn\'t start for this suite. Please check suite configuration or if the suite is empty.')
                    : null
                  ">
                    <button type="button" class="seh-view-report" [disabled]="!(entry.execution_id && entry.execution_id.$oid)"
                      (click)="viewReport(entry, $event)">
                      <span class="material-symbols-outlined" aria-hidden="true">description</span>
                      View Report
                    </button>
                  </div>
                </div>
              </div>
              <p *ngIf="!suiteEntries.length" class="seh-empty seh-empty--compact">No suite entries found.</p>
            </div>

            <footer
              *ngIf="!loadingSuites && !suiteErrorMessage && suiteTotalCount > 0"
              class="seh-pagination seh-pagination--suite"
              aria-label="Suite list pagination"
            >
              <!-- <span class="seh-pagination__summary">
                Showing {{ suiteRangeStart }}–{{ suiteRangeEnd }} of {{ suiteTotalCount }}
              </span> -->

              <div class="seh-pagination__controls">
                <button
                  type="button"
                  class="seh-page-btn"
                  [disabled]="suiteCurrentPage <= 1"
                  (click)="goToSuitePreviousPage()"
                >
                  Previous
                </button>

                <span class="seh-page-label">Page {{ suiteCurrentPage }} of {{ suiteTotalPages }}</span>

                <button
                  type="button"
                  class="seh-page-btn"
                  [disabled]="!suiteHasNext"
                  (click)="goToSuiteNextPage()"
                >
                  Next
                </button>
              </div>
            </footer>
          </div>
        </div>
      </div>

      <footer
        *ngIf="totalCount > 0"
        class="seh-pagination"
        aria-label="Schedule history pagination"
      >
        <span class="seh-pagination__summary">
          Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }}
        </span>

        <div class="seh-pagination__controls">
          <button
            type="button"
            class="seh-page-btn"
            [disabled]="currentPage <= 1"
            (click)="goToPreviousPage()"
          >
            Previous
          </button>

          <span class="seh-page-label">Page {{ currentPage }} of {{ totalPages }}</span>

          <button
            type="button"
            class="seh-page-btn"
            [disabled]="!hasNext"
            (click)="goToNextPage()"
          >
            Next
          </button>
        </div>
      </footer>
    </section>
  </ng-container>
</div>
